if (!customElements.get('tabbed-details')) {
  class TabbedDetails extends HTMLElement {
    constructor() {
      super();
      this.buttons = Array.from(this.querySelectorAll('.tabbed-details__tab-button'));
      this.panels  = Array.from(this.querySelectorAll('.tabbed-details__panel'));
      this.select  = this.querySelector('.tabbed-details__select');
    }

    connectedCallback() {
      this.buttons.forEach(btn =>
        btn.addEventListener('click', () => this.switchTab(btn.dataset.tab))
      );

      if (this.select) {
        this.select.addEventListener('change', () => this.switchTab(this.select.value));
      }
    }

    switchTab(key) {
      // Desktop buttons
      this.buttons.forEach(btn => {
        const active = btn.dataset.tab === key;
        btn.classList.toggle('tabbed-details__tab-button--active', active);
        btn.setAttribute('aria-selected', String(active));
      });

      // Mobile select stays in sync
      if (this.select && this.select.value !== key) {
        this.select.value = key;
      }

      // Panels
      this.panels.forEach(panel => {
        const active = panel.dataset.tabContent === key;
        panel.classList.toggle('tabbed-details__panel--active', active);
        panel.setAttribute('aria-hidden', String(!active));
      });
    }
  }

  customElements.define('tabbed-details', TabbedDetails);
}
